export var getIgnoreSocialDataForRegistration = function getIgnoreSocialDataForRegistration(socialType, config) {
  var falseSocials = config.getStrict('auth.ignoreSocialDataForRegistration.disabled');
  return !falseSocials.includes(socialType);
};